<div class="manage-add-container">
  <app-address-form
    (onSubmitAddAddress)="onSubmitAddAddress($event)"
    (onBackPreviousPage)="backToPreviousPage()"
    [editSelectedAddress]="editUserAddress"
    [isAddNewAddress]="true">
  </app-address-form>
</div>
